import * as Sentry from "@sentry/react";

export class SentryUtils {
  static init() {
    Sentry.init({
      dsn: "https://b5b8c1300ac16001b6310f9e4fd9a2b3@o4508704241287168.ingest.de.sentry.io/4510184326824016",
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      environment: "debug",
    });
  }

  // Logging an error without disrupting the user
  static exception = (error: unknown) => {
    Sentry.captureException(error);
  };

  // Logging a custom message with severity
  static customIssue = (
    message: string,
    level: "info" | "warning" | "error",
  ) => {
    Sentry.captureMessage(message, { level });
  };
}
